import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import Translate from '../../translate/Translate';
import {EntryController} from './Entry.controller';
import {EntryWizardComponent} from '../entry-wizard/EntryWizard.component';
import './Entry.style.scss';

export interface EntryProps {
    ctrl: EntryController;
}

@observer
export class EntryComponent extends TechseeBaseComponent<EntryProps> {
    private img = (name: string) => `/img/${name}`;

    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (ctrl.showWizard) {
            return <EntryWizardComponent ctrl={ctrl} />;
        }

        return (
            <div className='dashboard-entry-container' dir={ctrl.dir}>
                {ctrl.inSelectScreen() ? (
                    <div>
                        <h1 className='dashboard-entry-title text-center'>
                            <Translate text={ctrl.showWizard ? 'WIZARD.CONNECTION_WIZARD' : 'ENTRY.VIEW.WAITING'} />
                        </h1>

                        {ctrl.smsSendingMessage && (
                            <div className='dashboard-entry-sms-status text-center'>
                                <span>{ctrl.smsSendingMessage}</span>
                            </div>
                        )}

                        <div className='dashboard-entry-choose-title' dir={ctrl.dir}>
                            <Translate text='ENTRY.VIEW.CHOOSE' />
                        </div>

                        <hr className='dashboard-entry-separator' />

                        <div className='dashboard-entry-select-area text-center'>
                            <a
                                href='#'
                                className='dashboard-entry-select-button'
                                onClick={(e) => {
                                    e.preventDefault();
                                    ctrl.showInstructionsFor('android');
                                }}>
                                <img src={this.img('logo-android.png')} alt='Logo Android' />
                            </a>

                            <a
                                href='#'
                                className='dashboard-entry-select-button'
                                onClick={(e) => {
                                    e.preventDefault();
                                    ctrl.showInstructionsFor('apple');
                                }}>
                                <img src={this.img('logo-apple.png')} alt='Logo Apple' />
                            </a>
                        </div>

                        <hr className='dashboard-entry-separator' />

                        {ctrl.isMobile() && (
                            <div className='text-center dashboard-entry-end-button'>
                                {!ctrl.isObserveMode && (
                                    <a
                                        href='#'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            ctrl.endMeeting();
                                        }}
                                        className='text-center main-text-color'>
                                        <img src={this.img('close-session.png')} alt='Close session' />
                                        <br />
                                        <span>
                                            <Translate text='DASHBOARD.VIEW.END_MEETING' />
                                        </span>
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <div className={ctrl.isIE11 ? 'dashboard-entry-instructions-ie' : 'dashboard-entry-instructions'}>
                        <h1 className='dashboard-entry-title text-center'>
                            <Translate text={ctrl.showWizard ? 'WIZARD.CONNECTION_WIZARD' : 'ENTRY.VIEW.WAITING'} />
                        </h1>

                        <div>
                            <Translate text='ENTRY.VIEW.SCREENS' />
                        </div>
                        <hr className='dashboard-entry-separator' />

                        {ctrl.isVisible('android') && (
                            <img src={this.img('android-helper.png')} alt='Android instructions' />
                        )}

                        {ctrl.isVisible('apple') && <img src={this.img('apple-helper.png')} alt='Apple instructions' />}

                        <hr className='dashboard-entry-separator' />

                        <button className='btn btn-primary' onClick={ctrl.back}>
                            <Translate text='ENTRY.VIEW.BACK' />
                        </button>
                    </div>
                )}
            </div>
        );
    }
}
